import { FCX } from '@datassential/platform-ui-lib';
import cn from 'classnames';

export const InstantChartsColumn: FCX<{
    title: string;
    noResults?: boolean;
}> = ({ children, testId, className, title, noResults }) => (
    <div
        className={cn('InstantCharts__column', className)}
        data-testid={testId}
    >
        <div className={cn("InstantCharts__column-title", noResults && "is-dimmed")}>
            {title}
        </div>
        {children}
    </div>
);
